import { render, staticRenderFns } from "./compForm.vue?vue&type=template&id=73ce92b1&scoped=true&"
import script from "./compForm.vue?vue&type=script&lang=js&"
export * from "./compForm.vue?vue&type=script&lang=js&"
import style0 from "./compForm.vue?vue&type=style&index=0&id=73ce92b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ce92b1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73ce92b1')) {
      api.createRecord('73ce92b1', component.options)
    } else {
      api.reload('73ce92b1', component.options)
    }
    module.hot.accept("./compForm.vue?vue&type=template&id=73ce92b1&scoped=true&", function () {
      api.rerender('73ce92b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aliApp/nine/components/compForm.vue"
export default component.exports